import { DepositFieldType } from './DepositoryRequest';

export default (
    values: DepositFieldType,
    dpIdMap: Record<string, string>, 
): SubmitDepoRequestBody => {
    const { dpId, customDpId, query } = values;
    if (dpId === "other") {
        return {
            dpId: customDpId.slice(0, 8),
            clientId: customDpId.slice(8),
            query,
        };
    }
    return {
        dpId,
        clientId: dpIdMap[dpId],
        query,
    };
};
